// @ts-nocheck
import { formatMoney } from '@theme/money-formatting';

// Rounds to the nearest whole currency unit (nearest 100 minor units, e.g.
// cents) and strips the now-always-zero decimal portion from the formatted
// string, regardless of which separator/symbol the shop's money_format uses.
// Matches exactly 2 zeros (not 0+) so this can only ever be the decimal
// portion, never a "000" group from a thousands separator (e.g. "1.000,00"
// must become "1.000", not "1").
function formatMoneyNoDecimals(minorUnits, format, currency) {
    const roundedMinorUnits = Math.round(minorUnits / 100) * 100;
    return formatMoney(roundedMinorUnits, format, currency).replace(/[.,]00(?!\d)/, '');
}

class CustomPrice extends HTMLElement {
    constructor() {
        super();
        
        this.regularPriceEl = this.querySelector('.regular-price');
        this.launchPrice = this.closest('.product-price')?.querySelector('.launch-price');
    }

    connectedCallback() {
        // Wait for DOPP API to be ready
        if (window.RegiosDOPP?.api?.v0) {
            this.fetchDiscount(window.RegiosDOPP.api.v0);
        } else {
        window.addEventListener('regios-dopp:api-initialized', (event) => {
            this.fetchDiscount(event.detail.api);
        });
        }
    }

    setLaunchPrice() {
        const launchPriceEnd = this.launchPrice.getAttribute('data-launch-price-end');
        const inner = this.launchPrice.querySelector('[launch-price-inner]');

        if (
            launchPriceEnd &&
            inner
        ) {
            inner.textContent = `${inner.getAttribute('data-launch-price-text')} ${launchPriceEnd}`;
            this.launchPrice.classList.add('visible');
            this.launchPrice.closest('.product-price')?.classList.add('on-sale')
        }
    }

    async fetchDiscount(api) {
        const productId = parseInt(this.dataset.productId);
        const variantId = parseInt(this.dataset.variantId);
        const regularPriceInCents = parseInt(this.dataset.regularPriceCents);

        if (!productId || !variantId || !regularPriceInCents) {
        console.warn('custom-price: missing data attributes');
        return;
        }

        try {
        const { salePrice, regularPrice } = await api.calculateDiscountedPrices({
            productId,
            variantId,
            regularPriceInCents,
        });

        const discountAmount = regularPrice.amount - salePrice.amount;

        // Regios returns amounts in major units (e.g. 1092.50, not cents) -
        // formatMoney expects minor units, and applies the shop's own
        // money_format (market/currency-aware, same template Liquid's
        // | money filter uses for this request) instead of a hand-rolled
        // separator - this is what actually varies per currency (EUR uses
        // "." as the thousands separator, SEK uses a different one), which
        // a fixed .toFixed(2) + symbol never accounted for.
        const salePriceCents = Math.round(parseFloat(salePrice.amount) * 100);
        const regularPriceCents = Math.round(parseFloat(regularPrice.amount) * 100);

        this.regularPriceEl.textContent = formatMoneyNoDecimals(salePriceCents, Theme.store.money_format, Theme.store.currency_code);
        if(discountAmount > 0 && this.regularPriceEl){
            this.classList.add('discounted-product-item');

            if(this.launchPrice) {
                this.setLaunchPrice();
            }

            if(this.querySelector('.original-price')){
                this.querySelector('.original-price').textContent = formatMoneyNoDecimals(regularPriceCents, Theme.store.money_format, Theme.store.currency_code);
            }

            //badge
            const productItem = this.closest('.product-card');
            if(!productItem) return;

            const badge = productItem.querySelector('.product-card-badge');
            badge.classList.add('visible');
            badge.querySelector('.product-card-badge-text').classList.add('on-sale');
            const badgeText = badge.querySelector('.on-sale-badge-text');
            if(badgeText){
                badgeText.textContent =  `Save ${Math.floor((discountAmount) * 100 / regularPrice.amount)}%`;
            }         
        }
        } catch (err) {
        console.error('custom-price: DOPP calculation error:', err);
        }
    }
}

if (!customElements.get('custom-price')) {
  customElements.define('custom-price', CustomPrice);
}